import IKeyValue, { KeyValueValue } from '../../models/IKeyValue';
import fetch from '../fetch';

export interface SamplingConfig {
  endpoint: string;
  disabled?: boolean;
}

export interface SamplingMainData {
  application: string;
  env: string;
  deviceId: string;
  visitId: string;
}

export class Sampling {
  private static SAMPLING_UNKNOWN_USER_AGENT = 'unknown';

  private commonData: IKeyValue = {};

  constructor(private config: SamplingConfig, private mainData: SamplingMainData) {
    this.config = this.config || ({} as SamplingConfig);
    this.mainData = this.mainData || ({} as SamplingMainData);
    this.setCommonDataKey('platform', {
      userAgent: window?.navigator?.userAgent || Sampling.SAMPLING_UNKNOWN_USER_AGENT,
    });
  }

  public setCommonDataKey(key: string, value: KeyValueValue) {
    this.commonData[key] = value;
  }

  public event(action: string, data: IKeyValue) {
    const body = { ...this.mainData, action, timestamp: new Date(), data: { ...this.commonData, ...data } };

    console.log('[sampling]:', body);
    if (this.config.endpoint === undefined || this.config.disabled) {
      console.log('[sampling] disabled');
      return;
    }
    return fetch(this.config.endpoint, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  }
}
